/**
 * Banner
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="banner"></div>
 */
const {
  type
} = require("jquery");

$(function () {
  $('[data-component="banner"]').each(function () {
    let $holder = $(this);
    let $anchor = $('a[href*="#"]', $holder);

    if ($anchor.length) {
      $anchor.click(function (event) {
        event.preventDefault();
        var id = $(this).attr('href');
        $('html,body').animate({
          scrollTop: $(id).offset().top
        }, 500);
      });
    }
  });
});